// "vijayakumar.kode" -> "VK", "Asha Rao" -> "AR". Splits on spaces, dots,
// underscores and hyphens so email-style usernames initial cleanly.
export function initialsOf(name) {
  const parts = String(name || "")
    .split(/[\s._-]+/)
    .filter(Boolean);
  if (!parts.length) return "U";
  return (parts[0][0] + (parts[1]?.[0] || "")).toUpperCase();
}
